// Markt-Zuordnung fuer die Chips EU / US / Asien.
// Boersen-Kuerzel aus engine/base.py INDEX_MAP + Rohstoff-Kuerzel aus /scanner/signals.
// Amerika (Kanada, Brasilien) laeuft unter "US". Rohstoffe haben einen eigenen Chip,
// weil Max sie 08:00-22:00 handeln kann (Rueckmeldung 19.10.2026).
export type Market = "EU" | "US" | "ASIA" | "CMD";
export const MARKET_LABEL: Record<Market, string> = { EU: "EU", US: "US", ASIA: "Asien", CMD: "Rohstoffe" };
export const ALL_MARKETS: Market[] = ["EU", "US", "ASIA", "CMD"];

const US = new Set(["NYSE", "NASDAQ", "AMEX", "NYSE/NASDAQ", "TSX", "SAO", "BOVESPA"]);
// gleiche Liste wie der Rohstoff-Filter in api/routers/scanner.py
const CMD = new Set(["COMMODITY", "COMEX", "NYMEX", "LME", "ICE"]);
const ASIA = new Set(["TSE", "HKEX", "KRX", "NSE", "BSE", "ASX"]);

export function marketOf(exchange: string | null | undefined, indexMember?: string | null): Market {
  const ex = (exchange || "").toUpperCase();
  if (indexMember === "COMMODITY" || CMD.has(ex)) return "CMD";
  if (US.has(ex)) return "US";
  if (ASIA.has(ex)) return "ASIA";
  return "EU";
}

const berlinMinutes = (d: Date): number => {
  const parts = new Intl.DateTimeFormat("de-DE", { timeZone: "Europe/Berlin", hour: "2-digit", minute: "2-digit", hourCycle: "h23" })
    .formatToParts(d);
  const h = Number(parts.find(p => p.type === "hour")?.value ?? 0);
  const m = Number(parts.find(p => p.type === "minute")?.value ?? 0);
  return h * 60 + m;
};

export function berlinHHMM(d: Date): string {
  return new Intl.DateTimeFormat("de-DE", { timeZone: "Europe/Berlin", hour: "2-digit", minute: "2-digit", hourCycle: "h23" }).format(d);
}

// Spec 4.2: Auto-Auswahl nach Uhrzeit Europe/Berlin, plus Rohstoffe 08:00-22:00
export function autoMarkets(d: Date): Market[] {
  const t = berlinMinutes(d);
  if (t < 8 * 60) return ["ASIA"];
  if (t < 15 * 60 + 30) return ["EU", "CMD"];
  if (t < 17 * 60 + 30) return ["EU", "US", "CMD"];
  if (t < 22 * 60) return ["US", "CMD"];
  return ["EU", "US", "ASIA", "CMD"];
}
